export const GET_DEPARTMENTS_BEGIN = 'GET_DEPARTMENTS_BEGIN'
export const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS'
export const GET_DEPARTMENTS_ERROR = 'GET_DEPARTMENTS_ERROR'

export const DELETE_DEPARTMENT_BEGIN = 'DELETE_DEPARTMENT_BEGIN'
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS'
export const DELETE_DEPARTMENT_ERROR = 'DELETE_DEPARTMENT_ERROR'

export const CREATE_DEPARTMENT_BEGIN = 'CREATE_DEPARTMENT_BEGIN'
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS'
export const CREATE_DEPARTMENT_ERROR = 'CREATE_DEPARTMENT_ERROR'

export const UPDATE_DEPARTMENT_BEGIN = 'UPDATE_DEPARTMENT_BEGIN'
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS'
export const UPDATE_DEPARTMENT_ERROR = 'UPDATE_DEPARTMENT_ERROR'

export const ADD_USER_DEPARTMENT_BEGIN = 'ADD_USER_DEPARTMENT_BEGIN'
export const ADD_USER_DEPARTMENT_SUCCESS = 'ADD_USER_DEPARTMENT_SUCCESS'
export const ADD_USER_DEPARTMENT_ERROR = 'ADD_USER_DEPARTMENT_ERROR'

export const DELETE_USER_DEPARTMENT_BEGIN = 'DELETE_USER_DEPARTMENT_BEGIN'
export const DELETE_USER_DEPARTMENT_SUCCESS = 'DELETE_USER_DEPARTMENT_SUCCESS'
export const DELETE_USER_DEPARTMENT_ERROR = 'DELETE_USER_DEPARTMENT_ERROR'

export const CLEAR_NEW_DEPARTMENT_STATE = 'CLEAR_NEW_DEPARTMENT_STATE'